import React, { useState } from 'react';
import { Button, CircularProgress } from '@mui/material';
import { generateBuildingCompliancePDF, downloadPDF } from './PDFGenerator';
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";

/**
 * Button component for generating and downloading PDF reports
 * @param {Object} props - Component props
* @param {Object} props.pdfData - PDF data
 * @param {boolean} props.disabled - Whether the button is disabled
 */
  const PDFReportButton = ({ pdfData, leadComplianceData, statusCount, disabled }) => {
  const [loading, setLoading] = useState(false);

  const handleGeneratePDF = async () => {
    if (!leadComplianceData || disabled) return;

    setLoading(true);
    try {
      // Generate PDF
      console.log("pdf-data",leadComplianceData,statusCount);
      const doc = await generateBuildingCompliancePDF(leadComplianceData,statusCount);
      
      // Create filename
      const fileName = `${pdfData.client.company_name}_${pdfData.building.address.replace(/,|\s/g, '_')}_Compliance_Report.pdf`;
      
      // Download PDF
      downloadPDF(doc, fileName);
    } catch (error) {
      console.error("Error generating PDF:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button
      variant="contained"
      className="building-report-btn"
      onClick={handleGeneratePDF}
      disabled={disabled || loading}
      startIcon={loading ? <CircularProgress size={20} color="inherit" /> : <FileDownloadOutlinedIcon />}
    >
      {loading ? 'Generating...' : 'Building Report'}
    </Button>
  );
};

export default PDFReportButton; 